import { SHIPPING_ADDRESS_COLLECTION_PREFERENCES } from './constants'

export function isHideShippingAddress(shippingAddressCollectionPreference) {
  return (
    shippingAddressCollectionPreference ===
    SHIPPING_ADDRESS_COLLECTION_PREFERENCES.HIDE
  )
}
